export default "__VITE_ASSET__KNID3x1u__"